document.addEventListener('DOMContentLoaded', function () {
    const trimEndAndAppendEuro = (value) => {
      return '€' + value.slice(0, -1);
    }

    setTimeout(() => {
      const cartEl = document.querySelector('.upcart-checkout-button');

      if (cartEl) {
        const children = cartEl.children ?? [];

        if (children) {
          for (const child of children) {
            const value = child.innerText?.trim();

            if (value) {
              if (value.endsWith('€')) {
                const splitMiddle = child.innerText.split('•');

                if (splitMiddle.length) {
                  const newStr = splitMiddle[0] + '• ' + trimEndAndAppendEuro(splitMiddle[1].trim());
                  child.innerText = newStr;
                }
              }
            }
          }
        }
      }

      const element = document.querySelector('#CartPopup');

      if (element) {
        const observer = new MutationObserver((mutationList, observer) => {
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              for (let node of mutation.addedNodes) {
                if (!(node instanceof HTMLElement)) continue;
      
                  if (node.classList.contains('upcart-checkout-button-container')) {
                    const buttonElement = node.querySelector('.upcart-checkout-button');

                    if (buttonElement) {
                      setTimeout(() => {
                        const children = buttonElement.children ?? [];

                        if (children) {
                          for (const child of children) {
                            const value = child.innerText?.trim();

                            if (value) {
                              if (value.endsWith('€')) {
                                const splitMiddle = child.innerText.split('•');

                                if (splitMiddle.length) {
                                  const newStr = splitMiddle[0] + '• ' + trimEndAndAppendEuro(splitMiddle[1].trim());
                                  child.innerText = newStr;
                                }
                              }
                            }
                          }
                        }
                      }, 1500);
                    }
                  }
                }
            }
          }
        });
        
        observer.observe(element, {
          attributes: true, 
          childList: true, 
          subtree: true
        });
      }
    }, 2000);
  });